/* eslint-disable-next-line */
export const GET_RELEASES = 'GET_RELEASES'
